// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import { cloneElement, useCallback, useRef, useState } from "react";
import { Tooltip } from "antd";

// scrollWidth/clientWidth round to whole pixels, so a sub-pixel overflow still
// draws an ellipsis but compares equal. The probe marks where the text ends.
const isClipped = (el) => {
  if (el.scrollWidth > el.clientWidth) return true;
  const probe = document.createElement("span");
  el.appendChild(probe);
  const textEnd = probe.getBoundingClientRect().right;
  el.removeChild(probe);
  const { paddingRight, borderRightWidth } = getComputedStyle(el);
  const contentEnd =
    el.getBoundingClientRect().right -
    parseFloat(paddingRight) -
    parseFloat(borderRightWidth);
  return textEnd > contentEnd;
};

const RailTip = ({
  title,
  show = true,
  whenTruncated = false,
  placement = "right",
  mouseEnterDelay = 0.6,
  children,
}) => {
  const nodeRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  // Measure on enter rather than on mount: width depends on the sidebar's
  // resizable rail, and the row may not be laid out when it first renders.
  const measure = useCallback(() => {
    const el = nodeRef.current;
    if (!el) return;
    // The clipped node is the wrapper itself when it truncates, otherwise a
    // .truncate descendant (label sat beside an icon, say).
    const target =
      el.scrollWidth > el.clientWidth ? el : el.querySelector(".truncate") || el;
    setIsTruncated(isClipped(target));
  }, []);

  if (!show || !title) return children;

  if (whenTruncated) {
    const anchor = cloneElement(children, {
      ref: nodeRef,
      onMouseEnter: (e) => {
        measure();
        if (children.props.onMouseEnter) children.props.onMouseEnter(e);
      },
    });

    return (
      <Tooltip
        title={title}
        open={isTruncated ? undefined : false}
        placement={placement}
        color="white"
        mouseEnterDelay={mouseEnterDelay}
        overlayClassName="rail-tip"
        overlayStyle={{ maxWidth: "360px" }}
        overlayInnerStyle={{
          color: "#0A0A0A",
          fontSize: "12px",
          lineHeight: "16px",
          padding: "6px 12px",
          borderRadius: "8px",
          minHeight: "auto",
          boxShadow: "none",
        }}
      >
        {anchor}
      </Tooltip>
    );
  }

  return (
    <Tooltip
      title={title}
      placement={placement}
      color="white"
      mouseEnterDelay={mouseEnterDelay}
      overlayClassName="rail-tip"
      overlayStyle={{ maxWidth: "360px" }}
      overlayInnerStyle={{
        color: "#0A0A0A",
        fontSize: "12px",
        lineHeight: "16px",
        padding: "6px 12px",
        borderRadius: "8px",
        minHeight: "auto",
        boxShadow: "none",
      }}
    >
      {children}
    </Tooltip>
  );
};

export default RailTip;
